/**
 * ReactFlow configuration constants
 * Shared between MindMapFlow and MindMapFlowContent
 */

import {
  IdeaNode,
  InformationNode,
  NeedNode,
  SummarizedNode,
  VentureNode,
  StoryboardNode,
} from '../Nodes'
import { LabeledEdge } from '../Edges/LabeledEdge'

// Node types configuration
export const nodeTypes = {
  ideaNode: IdeaNode,
  informationNode: InformationNode,
  needNode: NeedNode,
  summarizedNode: SummarizedNode,
  ventureNode: VentureNode,
  storyboardNode: StoryboardNode,
}

// Edge types configuration
export const edgeTypes = {
  default: LabeledEdge,
}
